import ExaminationTimerProvider from './ExaminationTimerProvider';

export default ExaminationTimerProvider;
